import IFirm, { IFirmAddress } from "../interfaces/models/IFirm";

/**
 * Accounting / invoice mailing address only. Does not fall back to the firm's main office address.
 * Matches firm API shape: invoiceAddress may be a single object or an array (Cosmos).
 */
export function getAccountingMailingAddressForInvoice(
  firm: IFirm | null | undefined,
): IFirmAddress | undefined {
  if (!firm?.invoiceAddress) {
    return undefined;
  }
  const inv = firm.invoiceAddress as IFirmAddress | IFirmAddress[] | undefined;
  if (Array.isArray(inv)) {
    if (inv.length === 0) {
      return undefined;
    }
    const first = inv[0];
    if (first && typeof first === "object" && first.address1) {
      return first;
    }
    return undefined;
  }
  if (typeof inv === "object" && inv !== null && inv.address1) {
    return inv;
  }
  return undefined;
}
